var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    d: "M18.75 3H5.25C3.98438 3 3 4.01953 3 5.25V15.375C3 16.6406 3.98438 17.625 5.25 17.625H8.625V20.5781C8.625 20.8594 8.80078 21 9.04688 21C9.11719 21 9.1875 21 9.29297 20.9297L13.6875 17.625H18.75C19.9805 17.625 21 16.6406 21 15.375V5.25C21 4.01953 19.9805 3 18.75 3ZM19.3125 15.375C19.3125 15.6914 19.0312 15.9375 18.75 15.9375H13.125L12.668 16.2891L10.3125 18.0469V15.9375H5.25C4.93359 15.9375 4.6875 15.6914 4.6875 15.375V5.25C4.6875 4.96875 4.93359 4.6875 5.25 4.6875H18.75C19.0312 4.6875 19.3125 4.96875 19.3125 5.25V15.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallout);
export default __webpack_public_path__ + "static/media/Callout.d600d8e9f05376b09cf4673c6ceca12e.svg";
export { ForwardRef as ReactComponent };